import { useMutation, useQueryClient } from "@tanstack/react-query";
import giftCategoriesClient, {
  PendulumLogo,
} from "../../../../api/giftCategories";

const useUpdateLogoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, logo }: { id: string; logo: Partial<PendulumLogo> }) =>
      giftCategoriesClient.updateLogo(id, logo),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["logos"] });
    },
  });
};

export default useUpdateLogoMutation;
